import { createContext, useContext, useState, ReactNode, useEffect } from 'react';

interface TransactionContextType {
  newTransactionCount: number;
  setNewTransactionCount: (value: number) => void;
}

const TransactionContext = createContext<TransactionContextType | undefined>(undefined);

export const TransactionProvider = ({ children }: { children: ReactNode }) => {
  const [newTransactionCount, setNewTransactionCount] = useState(() => {
    if (typeof window !== 'undefined') {
      const savedCount = localStorage.getItem('newTransactionCount');
      return savedCount ? parseInt(savedCount, 10) : 0;
    }
    return 0;
  });

  useEffect(() => {
    if (typeof window !== 'undefined') {
      localStorage.setItem('newTransactionCount', newTransactionCount.toString());
    }
  }, [newTransactionCount]);

  return (
    <TransactionContext.Provider value={{ newTransactionCount, setNewTransactionCount }}>
      {children}
    </TransactionContext.Provider>
  );
};

export const useTransactionContext = () => {
  const context = useContext(TransactionContext);
  if (!context) {
    throw new Error('useTransactionContext must be used within a TransactionProvider');
  }
  return context;
};
